import { usePolicyContext } from "../../Contexts/AddPolicyContext";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import React from "react";
import dayjs from "dayjs";

function ReviewCard() {
  const { initialAddPolicyData, handleBack, isLoading, navigate } =
    usePolicyContext();

  // Log the initialAddPolicyData to see its structure and contents
  console.log("initialAddPolicyData:", initialAddPolicyData);

  const handleSubmit = async () => {
    console.log("Submitting data...");
    // Optionally log data when submit is triggered
    console.log("Data on submit:", initialAddPolicyData);

    navigate(`/add-policy/card-number/success`, { replace: true });
  };

  function capitalizeWords(name) {
    if (typeof name !== "string") {
      throw new TypeError("Expected a string");
    }
    return name
      .split(" ") // Split the name into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Join the words back into a single string
  }

  function formatSuffix(suffix) {
    if (suffix === "JR." || suffix === "SR.") {
      return suffix.charAt(0).toUpperCase() + suffix.slice(1).toLowerCase();
    }
    return suffix; // No change for Roman numerals or other suffixes
  }

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-center justify-center cursor-default">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-148 bg-white rounded-xl sm:mt-5 p-4">
          <div className="grid grid-cols-1 divide-y">
            <div className="mb-4">
              <KeyboardArrowLeft
                className="absolute cursor-pointer"
                onClick={handleBack}
              />
              <div className="text-center font-semibold text-[#1F2328]">
                Review card details
              </div>
            </div>

            <div>
              <div className="p-2">
                <div className="">
                  Before we dive in, let's make sure everything is just right.
                  Take a moment to review your policy details:
                </div>

                <div className="mt-5">
                  <div className="font-semibold">Contact Information</div>

                  <div className="mt-2">
                    <div className="text-sm text-[#60656D]">Mobile Number</div>
                    <div className=" text-[#60656D]">
                      +63{" "}
                      <span className="text-[#1F2328] font-semibold">
                        {initialAddPolicyData?.mobileNo.slice(1)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <div className=" font-semibold">Personal Information</div>

                  <div className="mt-1">
                    <div>
                      <div className="text-sm text-[#60656D]">Name</div>
                      <div className=" text-[#1F2328] font-semibold">
                        {`${capitalizeWords(
                          initialAddPolicyData.firstName
                        )} ${capitalizeWords(
                          initialAddPolicyData.middleName
                        )} ${capitalizeWords(initialAddPolicyData.lastName)} ${
                          initialAddPolicyData.suffixName !== ""
                            ? formatSuffix(initialAddPolicyData.suffixName)
                            : ""
                        }`}
                      </div>
                    </div>

                    <div className="mt-1">
                      <div className="text-sm text-[#60656D]">
                        Date of Birth
                      </div>
                      <div className=" text-[#1F2328] font-semibold">
                        {dayjs(initialAddPolicyData?.birthDate).format(
                          "MM/DD/YYYY"
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <div className=" font-semibold">Coverage</div>

                  <div className="w-full border border-[#E3E4E5] rounded-md mt-2">
                    <div className="grid grid-cols-1 divide-y p-3">
                      <div className="mb-2">
                        <div className="text-[#0947AB] font-semibold">
                          MyMaxicare
                        </div>

                        <div className=" text-[#383F49] mt-1">
                          A full HMO program for self-employed individuals or
                          families, tailor-fit to their budget and needs
                        </div>
                      </div>

                      <div>
                        {initialAddPolicyData?.plan.coverages.map(
                          (data, index) => (
                            <div
                              key={index}
                              id={index}
                              className="flex flex-row items-center mt-1 ml-2"
                            >
                              <img
                                className="w-6 h-6"
                                src={require("../../assets/check.png")}
                                alt="check"
                              />
                              <div className="text-[#1F2328] ml-1 font-medium">
                                {capitalizeWords(data)}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white flex-grow" />
          <div className="flex flex-col items-center w-full justify-center absolute p-4 inset-x-0 bottom-0 sm:relative sm:px-1">
            <Button
              disabled={isLoading}
              className={`h-14 w-full rounded-xl text-white ${
                isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB]"
              }`}
              onClick={handleSubmit}
            >
              {isLoading ? <CircularProgress size={"1rem"} /> : "Confirm"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewCard;
